<template>
    <div>
        <SiteHeader/>
        <keep-alive>
            <component :is="dynamicComponent" v-bind="currentProperties"></component>
        </keep-alive>

        <!-- Back to top -->
        <div class="container">
            <div class="backtotop">
                <div class="up-btn" id="backTotop">מעלה</div>
            </div>
        </div>

        <SiteFooter :makeupType="makeupType"/>
        <CookieConsent/>
    </div>
</template>

<script>
    import Home from './HomePage'
    import Gallery from './GalleryPage'
    import Category from './CategoryPage'
    import SiteHeader from './SiteHeader'
    import SiteFooter from './SiteFooter'
    import CookieConsent from './CookieConsent'

    export default {
        props: {
            currentTab: String
        },
        data() {
            let tabs =  {
                "index.html" : {component: Home, makeupType: "איפור", props: false},
                "gallery.html" :{component: Gallery, makeupType: "איפור כלות", props: false},
                "bride.html": {component: Category, makeupType: "איפור כלות", props: {categoryJsonUrl: "/json/bride.json"}},
                "evening.html" : {component:Category, makeupType: "איפור ערב", props: {categoryJsonUrl: "/json/evening.json"}},
                "makeup-and-hair.html" : {component:Category, makeupType: "איפור ושיער", props: {categoryJsonUrl: "/json/makeup_and_hair.json"}},
                "purim.html" : {component:Category, makeupType: "איפור אפקטים/תחפושת/סרטים", props: {categoryJsonUrl: "/json/purim.json"}},
                "ashdod.html" : {component:Category, makeupType: "איפור ושיער", props: {categoryJsonUrl: "/json/ashdod.json"}},
                "ashdod2.html" : {component:Category, makeupType: "איפור ושיער", props: {categoryJsonUrl: "/json/ashdod2.json"}}
            };

            // Support clean URLs without .html
            tabs[""] = tabs["index.html"];
            tabs["index"] = tabs["index.html"];
            tabs["gallery"] = tabs["gallery.html"];
            tabs["bride"] = tabs["bride.html"];
            tabs["evening"] = tabs["evening.html"];
            tabs["makeup-and-hair"] = tabs["makeup-and-hair.html"];
            tabs["purim"] = tabs["purim.html"];
            tabs["ashdod"] = tabs["ashdod.html"];
            tabs["ashdod2"] = tabs["ashdod2.html"];

            let resolvedTab = this._props.currentTab || "index.html";
            let resolvedPage = tabs[resolvedTab] || tabs["index.html"];

            return {
                pages: tabs,
                makeupType: resolvedPage.makeupType
            }
        },
        components: {
            SiteHeader,
            SiteFooter,
            CookieConsent
        },
        mounted() {
            var preloder = document.getElementById('preloder');
            if (preloder) {
                preloder.remove();
            }
        },
        watch:{
            $route (to) {
                if (to.hash === "") {
                    let pageName = to.path.replace("/", "")
                    if (this.pages[pageName]) {
                        // collapse header menu if opened
                        if (typeof $ !== 'undefined' && $("#collapsibleNavId").hasClass("show"))
                            $('.navbar-toggler').click();

                        // scroll up
                        if (typeof $ !== 'undefined') {
                            $("html, body").animate({scrollTop: 0}, 100);
                        } else {
                            window.scrollTo(0, 0);
                        }

                        // update makeup type on "contact" section
                        this._data.makeupType = this.pages[pageName].makeupType;
                    }
                } else {
                    return false;
                }
            }
        },
        computed: {
            dynamicComponent() {
                let tab = this._props.currentTab || "index.html";
                let page = this.pages[tab];
                if (page)
                    return page.component;
                else
                    return Home
            },
            currentProperties: function() {
                let tab = this._props.currentTab || "index.html";
                let page = this.pages[tab];
                if (page)
                    return page.props;
                else
                    return false;
            }
        }
    }
</script>